(function () {
  'use strict';

  var CFG = window.__colorI18n || {};
  var dict = null;        // 词典：{ "Black": "Melna", ... }
  var translated;         // 已译文集合（Object.create(null)），防重复翻译与死循环
  var keyTpls = [];       // {{key}} 锚点模板：{ text: 原词条, to: 译文, lits: 字面段数组, nslots: 槽数 }
  var scheduled = [];     // 待扫描根节点
  var timer = null;

  /* 已知渲染点兜底选择器（Liquid 未加标记时也能覆盖，词典未收录则保持原文） */
  var FALLBACK = [
    '.ql-fl-capitalize',
    '#__pf',
    '#__pf *',    // pageFly插件页面
    '.color-swatch__item p',
    '.combo-box__option-item',
    '.select__selected-value',
    '.product-form__option-name',
    '.ql-option-color',
    '.usf-predictive-search__viewall',
    '.usf-is__viewall',
    '.usf-badge',
    '.usf-more',
    '.usf-predictive-search__category',
    '.usf-search-box',
    '.usf-c-select__btn',
    '.usf-c-select__input-value',
    '.usf-clear-all',
    '.custom-dot',
    '.selector-wrapper label b',                //options
    '.cc-swatches__label',                          // PDP/商品卡 选中颜色名
    '.cc-swatches a',                               // usf.js Vue 卡片色块 + PDP 色块
    '.clickyboxes.options--color a',                // 无分组时的颜色色块列表
    '.ql-color-group-list label b',                 // 颜色分组标题
    '#ql-remomend-color-box .ql-re-title .qlselect', // 颜色推荐框标题
    '#ql-remomend-color-box .re-color',             // 颜色推荐框 "查看该颜色"
    '.color-name',                                  // 推荐框/快速购 卡片色名
    '.color-group',                                  // 推荐框 "Color" 固定词条
    '.instafeed-product-name',                         // ins 视频中的产品链接名
    '.product-block__inner .subtitle',
    '.product-area__subtitle',                          // 产品副标题
    ".usf-is-no-results",                               // 搜索结果空态（文本在子 div，含 <b>搜索词</b>）
    ".usf-is-no-results *",                               // 搜索结果空态（文本在子 div，含 <b>搜索词</b>）
    ".usf-predictive-search__no-results",               // 预测搜索空态 "No matches found for ..."
    ".usf-is-did-you-mean",                             // "Sorry, nothing found ... Did you mean ...?"
    ".usf-sr-empty span",                                // 搜索页无结果 "No matching for ..."（loc.productSearchNoResults）
    ".usf-sr-summary",                                   // 搜索页总结 "1-12 of 120 products"
    ".usf-label",
    "input[placeholder]",                              // 输入框占位文案（搜索框等），文本为空、只存在于属性上
    "[data-pf-type]",
    "[data-pf-type] *"
  ];
  /* 组合串替换规则（RULES）：部分文本是「颜色词 + 固定后缀」的组合串（如筛选组标题 'Color (13)'），
     只需翻译前半部分、其余原样保留。写法：sel = 生效选择器；re = 匹配整串的正则，
     第 1 个捕获组 = 需要查词典替换的部分；规则在「整串精确匹配」失败后才会尝试。
     捕获组含动态数字时，引擎会把数字归一为 {{num}} 查「模板词条」再回填（见 lookupTemplate）。
     RULES 的选择器会自动纳入扫描范围（无需重复加进 FALLBACK）；只作用于文本，不作用于 title。 */
  var RULES = [
	{ sel: '.usf-product-total', re: /^(VIEW\s+\d+\s+ITEMS)$/ }, // 'VIEW 48 ITEMS' → 查 'VIEW {{num}} ITEMS' 词条（模板词条），'{{num}}' 回填 48
	{ sel: '.usf-sr-more .usf-title', re: /^(You['’]ve viewed \d+ of \d+ products)$/ }, // "You've viewed 40 of 48 products" → 查 "You've viewed {{num}} of {{num}} products" 词条，按序回填 40、48
	{ sel: '.usf-sr-summary', re: /^\d+\s+(products)$/ }, // '48 products' → 只翻译 'products'，数字原位保留
    { sel: '.usf-label', re: /^(.+?)\s*\(\s*\d+\s*\)$/ }  // 筛选组标题 'Color (13)' → 只翻译 'Color'
  ];
  var QUERY = '[data-color-text],[data-color-variant],' + FALLBACK.join(',');
  for (var i = 0; i < RULES.length; i++) QUERY += ',' + RULES[i].sel;

  /* ---------- 语言检测：Liquid 注入（权威）→ html lang → URL 首段 ---------- */
  var locale = String(CFG.locale || document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (!locale) {
    locale = String(location.pathname.split('/')[1] || '').toLowerCase();
  }
  /* 源语言 = 店铺默认语言（可能为德语、es-MX 等，不假定为英文）；Liquid 未下发时按 en 兜底 */
  var source = String(CFG.source || 'en').toLowerCase();
  if (!CFG.dictUrl || !locale || locale === source) return; // 默认语言页/未配置 → 静默停用

  /* ---------- 基础工具 ---------- */
  function lookup(text) {
    if (!dict || !text) return null;
    if (!Object.prototype.hasOwnProperty.call(dict, text)) return null;
    var to = dict[text];
    return (to && to !== text) ? to : null;
  }

  function isTranslated(text) {
    return !!(text && translated && translated[text]);
  }

  /* 写入译文，仅改文本节点，不重建 innerHTML：
     1) 命中单个内容等于 from 的文本节点 → 原位替换；
     2) 元素无子元素 → 直接设 textContent；
     3) 混合结构（文本被 <b>搜索词</b> 等内联元素、或拆进 <h2>+<p> 等多个子元素）
        → 交给 writeMixedText 分段回填；slots 为 {{key}} 模板的变量位原值，用于保护内联变量。 */
  function writeText(el, from, to, slots) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      var value = node.nodeValue;
      if (value && value.trim() === from) {
        node.nodeValue = value.replace(from, to);
        return true;
      }
    }
    if (!el.firstElementChild) {
      el.textContent = to;
      return true;
    }
    return writeMixedText(el, from, to, slots);
  }

  /* 混合结构写入：整句文本可能被拆进多个子元素（如 .usf-sr-empty span 下的 <h2>+<p>，
     或 .usf-is-no-results 下的文本 div），无法靠单个文本节点或 textContent 直接覆盖。
     依次尝试三种策略，任一成功即返回，全部失败则保持原文（绝不误伤结构）：
     1) applyMixed：容器直接子节点即「文本-内联元素」交替时，按内联元素文本作锚点切段回填；
     2) 下钻：递归进 textContent 仍等于 from 的子容器再试 1)；
     3) flattenMixed：兜底，摊平整棵子树的后代文本节点跨块级边界回填。 */
  function writeMixedText(el, from, to, slots) {
    if (applyMixed(el, to)) return true;
    var kids = el.children;
    for (var i = 0; i < kids.length; i++) {
      if ((kids[i].textContent || '').trim() === from && writeMixedText(kids[i], from, to, slots)) return true;
    }
    return flattenMixed(el, from, to, slots);
  }

  /* 在单一容器内按「非空白文本节点」与「元素子节点（变量位）」交替排列的假设回填译文：
     文本节点数须恰为元素子节点数 + 1，且各元素文本能在译文中按序定位（变量位原样保留、不翻译），
     据此把译文切成段写回各文本节点。任一条件不满足 → 放弃（返回 false，保持原文）。 */
  function applyMixed(box, to) {
    var kids = box.childNodes, texts = [], elems = [], i;
    for (i = 0; i < kids.length; i++) {
      var nd = kids[i];
      if (nd.nodeType === 3) { if (nd.nodeValue.trim()) texts.push(nd); }
      else if (nd.nodeType === 1) elems.push(nd);
    }
    if (!elems.length || texts.length !== elems.length + 1) return false;
    var cursor = 0, segs = [];
    for (i = 0; i < elems.length; i++) {
      var val = elems[i].textContent;
      if (!val) return false;
      var p = to.indexOf(val, cursor);
      if (p < cursor) return false; // 变量位在译文中定位失败 → 放弃
      segs.push(to.slice(cursor, p));
      cursor = p + val.length;
    }
    segs.push(to.slice(cursor));
    for (i = 0; i < texts.length; i++) texts[i].nodeValue = segs[i];
    return true;
  }

  /* 摊平回填：按文档顺序收集 el 子树全部后代文本节点，其拼接须精确等于 from；
     再依 slots（变量位原值，如 <b> 内搜索词）把序列切成「字面段 / 变量位」交替分组——
     变量位节点原样保留并作为在译文中定位的锚点，每个字面段用 distributeText 回填到段内各节点。
     因摊平可跨 <h2>/<p> 等块级边界，整句被拆进多个子元素时也能正确写回。 */
  function flattenMixed(el, from, to, slots) {
    var nodes = [], walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false), nd, i;
    while ((nd = walker.nextNode())) nodes.push(nd);
    if (!nodes.length) return false;
    var vals = [];
    for (i = 0; i < nodes.length; i++) vals.push(nodes[i].nodeValue);
    if (vals.join('') !== from) return false; // 拼接与整串不一致 → 放弃，避免错位
    var slotSet = {};
    if (slots) for (i = 0; i < slots.length; i++) if (slots[i]) slotSet[slots[i]] = true;
    var seq = [], run = null;
    for (i = 0; i < nodes.length; i++) {
      if (slotSet[vals[i].trim()]) {
        if (run) { seq.push(run); run = null; }
        seq.push({ slot: i });
      } else {
        if (!run) run = { run: [] };
        run.run.push(i);
      }
    }
    if (run) seq.push(run);
    var out = vals.slice(), cursor = 0;
    for (i = 0; i < seq.length; i++) {
      var item = seq[i];
      if (item.slot !== undefined) {
        var sv = vals[item.slot];
        var sp = sv ? to.indexOf(sv, cursor) : -1;
        if (sp < cursor) return false; // 变量位在译文中缺失 → 放弃
        cursor = sp + sv.length;        // 变量位节点保持不变
      } else {
        var idxs = item.run, oldVals = [], j;
        for (j = 0; j < idxs.length; j++) oldVals.push(vals[idxs[j]]);
        var litNew;
        if (i === seq.length - 1) {
          litNew = to.slice(cursor);
        } else {
          var nsv = vals[seq[i + 1].slot];
          var np = nsv ? to.indexOf(nsv, cursor) : -1;
          if (np < cursor) return false;
          litNew = to.slice(cursor, np);
        }
        var dist = distributeText(oldVals, litNew);
        if (!dist) return false;
        for (j = 0; j < idxs.length; j++) out[idxs[j]] = dist[j];
        cursor += litNew.length;
      }
    }
    for (i = 0; i < nodes.length; i++) if (nodes[i].nodeValue !== out[i]) nodes[i].nodeValue = out[i];
    return true;
  }

  /* 把字面段译文 litNew 回填到原本承载 oldVals（拼接为 oldText）的多个文本节点：
     求 oldText 与 litNew 的公共前缀 p、公共后缀 s，中间变化串整体放进跨越 p 的那个节点，
     其余节点按原边界取公共前/后缀对应内容——故纯首尾增删时各节点原样保留、增量落到边界节点。
     单节点直接整体赋值。 */
  function distributeText(oldVals, litNew) {
    if (!oldVals.length) return [];
    if (oldVals.length === 1) return [litNew];
    var oldText = oldVals.join(''), p = 0, s = 0, i;
    var mp = Math.min(oldText.length, litNew.length);
    while (p < mp && oldText.charAt(p) === litNew.charAt(p)) p++;
    var ms = Math.min(oldText.length - p, litNew.length - p);
    while (s < ms && oldText.charAt(oldText.length - 1 - s) === litNew.charAt(litNew.length - 1 - s)) s++;
    var mid = litNew.slice(p, litNew.length - s);
    var ts = oldText.length - s;
    var out = [], pos = 0, placed = false;
    for (i = 0; i < oldVals.length; i++) {
      var v = oldVals[i], start = pos, end = pos + v.length; pos = end;
      var nv = '';
      if (start < p) nv += litNew.slice(start, Math.min(end, p));
      if (!placed && ((start <= p && p < end) || (p >= oldText.length && i === oldVals.length - 1))) {
        nv += mid; placed = true;
      }
      if (end > ts) {
        var a = Math.max(start, ts) - ts, b = Math.min(end, oldText.length) - ts;
        nv += litNew.slice(litNew.length - s + a, litNew.length - s + b);
      }
      out.push(nv);
    }
    if (!placed) out[out.length - 1] += mid;
    return out;
  }

  /* ---------- 翻译：单值 / {{key}} 锚点模板 / 逐文本节点兜底 / 变体组合串 / 组合串正则 ---------- */

  /* 逐文本节点兜底（整串精确与 {{key}} 锚点模板都失败后触发）：
     PageFly 常把整段多句文案合并进同一元素、仅用 <br> 拆成多个直接子文本节点
     （如「引言 + 5 条 * 条款」整块 678 字符），整串永远查不到词典；此时逐节点按
     与整串相同的匹配链（精确 → {{num}} 模板 → {{key}} 锚点）原位替换命中的节点，
     未命中的保持原文。只处理直接子文本节点：元素子节点会作为独立元素另行扫描，此处不下钻。 */
  function translateNodes(el) {
    var kids = el.childNodes, changed = false;
    for (var i = 0; i < kids.length; i++) {
      var node = kids[i];
      if (node.nodeType !== 3) continue;
      var value = node.nodeValue;
      if (!value) continue;
      var from = value.trim();
      if (!from || isTranslated(from)) continue;
      var to = lookup(from) || lookupTemplate(from);
      if (!to) {
        var kt = lookupKeyTemplate(from);
        if (kt) to = kt.to;
      }
      if (!to) continue;
      node.nodeValue = value.replace(from, to);
      changed = true;
    }
    return changed;
  }

  function translateText(el) {
    var current = (el.textContent || '').trim();
    if (!current || isTranslated(current)) return false;
    var to = lookup(current);
    if (to) return writeText(el, current, to);
    var kt = lookupKeyTemplate(current); // 整串不中 → 尝试 {{key}} 锚点模板
    if (kt) return writeText(el, current, kt.to, kt.slots);
    return translateNodes(el); // 整串/模板都不中 → 逐文本节点兜底
  }

  function translateVariantTitle(el) {
    var current = (el.textContent || '').trim();
    if (!current || isTranslated(current)) return;
    var to = lookup(current);
    if (to) {
      writeText(el, current, to);
      return;
    }
    if (current.indexOf(' / ') === -1) return;
    var parts = current.split(' / ');
    var changed = false;
    var out = [];
    for (var i = 0; i < parts.length; i++) {
      var piece = parts[i].trim();
      var pieceTo = isTranslated(piece) ? null : lookup(piece);
      if (pieceTo) {
        out.push(pieceTo);
        changed = true;
      } else {
        out.push(piece);
      }
    }
    if (changed) writeText(el, current, out.join(' / '));
  }

  /* 模板词条回退：把文本里的数字段归一为 {{num}} 后查词典（如 'VIEW 48 ITEMS' → 'VIEW {{num}} ITEMS'），
     命中后按序把数字回填进译文的 {{num}} 占位符；占位符数量与数字个数不一致 → 视为未收录，保持原文 */
  function lookupTemplate(text) {
    var nums = [];
    var key = text.replace(/\d+/g, function (n) {
      nums.push(n);
      return '{{num}}';
    });
    if (key === text) return null; // 无数字 → 不走模板
    var to = lookup(key);
    if (!to) return null;
    var slots = to.match(/\{\{num\}\}/g);
    if (!slots || slots.length !== nums.length) return null; // 占位符数量不匹配 → 保持原文
    var i = 0;
    return to.replace(/\{\{num\}\}/g, function () {
      return nums[i++];
    });
  }

  /* ---------- {{key}} 文字位锚点模板 ----------
     采集自 usf.settings['translation'] 等来源的词条，文字参数位统一写成 {{key}}
     （如 'view all results for {{key}}'）。页面渲染文本里该位置出现的是一段自由文字
     （搜索词、筛选组名等），无法像数字那样用 \d+ 识别，因此反过来用词条里的固定字面段
     做锚点：整串精确匹配失败后，按「首段开头、中间段顺序出现、尾段收尾」归一页面文本，
     提取各变量段回填进译文；变量段本身若收录于词典（颜色词等）则顺带翻译。
     匹配约束：每个变量段必须非空且长度 ≤ MAX_KEY_SLOT，防止锚点间吞入整段无关文字。 */
  var MAX_KEY_SLOT = 80;
  function buildKeyTemplates() {
    keyTpls = [];
    for (var key in dict) {
      if (!Object.prototype.hasOwnProperty.call(dict, key) || !dict[key]) continue;
      if (key.indexOf('{{key}}') === -1) continue;
      var lits = key.split('{{key}}');
      var weight = 0;
      for (var i = 0; i < lits.length; i++) weight += lits[i].length;
      keyTpls.push({ text: key, lits: lits, re: buildKeyRe(lits), weight: weight });
    }
    /* 字面段越长 → 锚点越具体，优先尝试 */
    keyTpls.sort(function (a, b) { return b.weight - a.weight; });
  }

  /* 把字面段编成「空白宽容」正则：转义特殊字符后，将段内每段空白替换为 \s*，
     使词典里人类可读的空格（句间空格等）能匹配渲染 textContent 里被块级标签（</h2><p>）吞掉的空白。 */
  function flexLit(lit) {
    return lit.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/[ \t\r\n\u00a0\u3000]+/g, '\\s*');
  }
  function buildKeyRe(lits) {
    var cap = '([\\s\\S]{1,' + MAX_KEY_SLOT + '}?)'; // 变量位：非空、≤MAX_KEY_SLOT、非贪婪
    try { return new RegExp('^' + lits.map(flexLit).join(cap) + '$'); }
    catch (e) { return null; }
  }

  function matchKeyTpl(tpl, text) {
    if (!tpl.re) return null;
    var m = tpl.re.exec(text);
    if (!m) return null;
    var slots = [];
    for (var i = 1; i < m.length; i++) {
      var slot = (m[i] || '').trim();
      if (!slot || slot.length > MAX_KEY_SLOT) return null;
      slots.push(slot);
    }
    return slots;
  }

  function lookupKeyTemplate(text) {
    if (!keyTpls.length) return null;
    for (var t = 0; t < keyTpls.length; t++) {
      var tpl = keyTpls[t];
      var slots = matchKeyTpl(tpl, text);
      if (!slots) continue;
      var to = lookup(tpl.text);
      if (!to) continue;
      var parts = to.split('{{key}}');
      if (parts.length - 1 !== slots.length) continue; // 译文占位符数量不符 → 视为未收录
      var out = '';
      for (var s = 0; s < slots.length; s++) {
        var val = lookup(slots[s]) || lookupTemplate(slots[s]) || slots[s];
        out += parts[s] + val;
      }
      out += parts[slots.length];
      if (out && out !== text) return { to: out, slots: slots }; // slots 为原文变量位，供写回时保护内联变量
    }
    return null;
  }

  /* 组合串正则：整串精确匹配失败时，按 RULES 提取可翻译部分，只替换该部分（如 'Color (13)'→'Farbe (13)'） */
  function translateRule(el) {
    var current = (el.textContent || '').trim();
    if (!current) return;
    for (var i = 0; i < RULES.length; i++) {
      var rule = RULES[i];
      if (!el.matches || !el.matches(rule.sel)) continue;
      var m = current.match(rule.re);
      if (!m || !m[1]) continue;
      var part = m[1].trim();
      if (!part || isTranslated(part)) return; // 已译文 → 不再处理，防死循环
      var to = lookup(part) || lookupTemplate(part);
      if (!to) return; // 未收录 → 保持原文
      var start = m.index + m[0].indexOf(m[1]);
      writeText(el, current, current.slice(0, start) + to + current.slice(start + m[1].length));
      return;
    }
  }

  /* 翻译 title 属性（纯展示工具提示；仅精确匹配整串，不拆分分段） */
  function translateTitleAttr(el) {
    if (!el || !el.getAttribute) return;
    var t = el.getAttribute('title');
    if (!t) return;
    var from = t.trim();
    if (!from || isTranslated(from)) return;
    var to = lookup(from);
    if (to) el.setAttribute('title', to);
  }
  
  /* 翻译 placeholder 属性（输入框占位文案，如 "Type to search"；与采集端 attr:"placeholder" 词条对应）。
     属性值无逐节点/混合结构语义，故匹配链只走 精确 → {{num}} 数字模板（占位文案含商品数等动态数字的场景） */
  function translatePlaceholderAttr(el) {
    if (!el || !el.getAttribute) return;
    var p = el.getAttribute('placeholder');
    if (!p) return;
    var from = p.trim();
    if (!from || isTranslated(from)) return;
    var to = lookup(from) || lookupTemplate(from);
    if (to) el.setAttribute('placeholder', to);
  }

  function scan(el) {
    if (!el || el.nodeType !== 1) return;
    if (el.hasAttribute('data-color-variant')) translateVariantTitle(el);
    else if (!translateText(el)) translateRule(el); // 整串不中 → 尝试组合串正则
    translateTitleAttr(el);
    translatePlaceholderAttr(el);
  }

  function translateAll(root) {
    if (!dict) return;
    if (!root || root.nodeType !== 1) root = document.documentElement;
    scan(root);
    var nodes = root.querySelectorAll(QUERY);
    for (var i = 0; i < nodes.length; i++) scan(nodes[i]);
  }

  /* ---------- 动态内容：防抖增量扫描（切色块/推荐框/购物车/Vue 重渲染） ---------- */
  function schedule(node) {
    if (!node || node.nodeType !== 1) return;
    scheduled.push(node);
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      var list = scheduled;
      scheduled = [];
      for (var i = 0; i < list.length; i++) translateAll(list[i]);
    }, 50);
  }

  function handleMutations(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'childList') {
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1) schedule(n);
          else if (n.nodeType === 3 && n.parentElement) schedule(n.parentElement);
        }
      } else if (m.type === 'characterData' && m.target.parentElement) {
        schedule(m.target.parentElement);
      }
    }
  }

  /* ---------- 启动 ---------- */
  function bootstrap() {
    var req;
    try {
      req = window.fetch ? window.fetch(CFG.dictUrl, { credentials: 'omit' }) : null;
    } catch (e) {
      req = null;
    }
    if (!req || !req.then) return;
    req.then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    }).then(function (data) {
      if (!data || typeof data !== 'object' || Array.isArray(data)) return;
      dict = data;
      translated = Object.create(null);
      for (var key in dict) {
        if (Object.prototype.hasOwnProperty.call(dict, key) && dict[key]) {
          translated[dict[key]] = true;
        }
      }
      buildKeyTemplates();
      translateAll(document.documentElement);
      if (typeof MutationObserver === 'function') {
        new MutationObserver(handleMutations).observe(document.documentElement, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    })['catch'](function () {
      /* 词典缺失 / 网络异常 → 静默停用 */
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
